import script from "./ModelBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelBtn.vue?vue&type=script&setup=true&lang=js"

import "./ModelBtn.vue?vue&type=style&index=0&id=bd6bd236&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd6bd236"]])

export default __exports__